module.exports = __webpack_public_path__ + "img/141.213d4988.jpg";